import type { KeyboardEvent as ReactKeyboardEvent } from "react";
import clsx from "clsx";
import type { ElementGroupSelectableRowProps } from "./types";

export const ElementGroupSelectableRow = ({
  isSelected,
  onClick,
  rowRef,
  left,
  right,
  endAdornment,
  className,
  containerClassName,
  children,
  dataOnboarding,
}: ElementGroupSelectableRowProps) => {
  const handleKeyDown = (event: ReactKeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <li
      ref={rowRef}
      className={containerClassName}
      data-onboarding={dataOnboarding}
    >
      <div
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={handleKeyDown}
        className={clsx(
          "w-full px-2 py-2 flex items-center justify-between gap-2 text-left transition-colors cursor-pointer",
          isSelected ? "bg-blue-50 hover:bg-blue-50" : "hover:bg-gray-50",
          className,
        )}
      >
        <div className="flex items-center gap-2 min-w-0">{left}</div>
        <div className="flex items-center gap-3 shrink-0">
          {right}
          {endAdornment}
        </div>
      </div>
      {children}
    </li>
  );
};
